import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { prepareAuthHeaders } from '../../utils/prepareAuthHeaders';

export const scheduleApi = createApi({
    reducerPath: 'scheduleApi',
    keepUnusedDataFor: 0,
    baseQuery: fetchBaseQuery({
        baseUrl: '/Schedule',
        prepareHeaders: prepareAuthHeaders,
    }),
    endpoints: (builder) => ({
        getScheduleByPerson: builder.query({
            query: ({ data }) => ({
                url: `/GetScheduleByPerson`,
                method: 'GET',
                params: data
            }),
        }),
        getCurrentWeekNumber: builder.query({
            query: () => ({
                url: `/GetCurrentWeekNumber`,
                method: 'GET'
            }),
        }),
        updateUnlinkedTeamsSchedule: builder.mutation({
            query: () => ({
                url: `/UpdateUnlinkedTeamsSchedule`,
                method: 'POST'
            }),
            invalidatesTags: ['Post'],
        }),
        assignScheduleToVirtualGroups: builder.mutation({
            query: () => ({
                url: `/AssignScheduleToVirtualGroups`,
                method: 'POST'
            }),
            invalidatesTags: ['Post'],
        }),
        removeScheduleLessonDetails: builder.mutation({
            query: ({ data }) => ({
                url: `/RemoveScheduleLessonDetails`,
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['Post'],
        }),
    }),
});

export const {
    useLazyGetScheduleByPersonQuery,
    useGetCurrentWeekNumberQuery,
    useUpdateUnlinkedTeamsScheduleMutation,
    useAssignScheduleToVirtualGroupsMutation,
    useRemoveScheduleLessonDetailsMutation
} = scheduleApi;
